import type { QueryClient } from '@tanstack/react-query';
import { LoopsApi } from '@/lib/api/item-store/loops';
import type { Loop } from '@/lib/api/types/loops';
import { commonQueryKeys } from '@/lib/query-keys/common';
import { SELECTED_LOOP_STORAGE_KEY } from '@/lib/utils/loop/loopStorageKeys';

export const readStoredLoopId = (): number | undefined => {
  try {
    const stored = localStorage.getItem(SELECTED_LOOP_STORAGE_KEY);
    const parsed = stored ? Number(stored) : Number.NaN;
    return Number.isFinite(parsed) ? parsed : undefined;
  } catch {
    return undefined;
  }
};

export async function selectLoop(
  queryClient: QueryClient,
  organizationId: string,
): Promise<Loop | undefined> {
  const loopsResponse = await queryClient.ensureQueryData({
    queryKey: commonQueryKeys.loops.all(organizationId),
    queryFn: () => LoopsApi.getLoops(),
  });
  const loops = loopsResponse.data;

  const storedLoopId = readStoredLoopId();
  const lastVisited = storedLoopId ? loops.find((loop) => loop.id === storedLoopId) : undefined;

  if (lastVisited) {
    return lastVisited;
  }

  return [...loops].sort(
    (loopA, loopB) => new Date(loopB.createdAt).getTime() - new Date(loopA.createdAt).getTime(),
  )[0];
}
